/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedWorkLogRouteImport } from './routes/_authenticated/workLog'
import { Route as AuthenticatedUserRouteImport } from './routes/_authenticated/user'
import { Route as AuthenticatedUnauthorizedRouteImport } from './routes/_authenticated/unauthorized'
import { Route as AuthenticatedUbicationRouteImport } from './routes/_authenticated/ubication'
import { Route as AuthenticatedReportRouteImport } from './routes/_authenticated/report'
import { Route as AuthenticatedNoteRouteImport } from './routes/_authenticated/note'
import { Route as AuthenticatedNewCollaboratorRouteImport } from './routes/_authenticated/newCollaborator'
import { Route as AuthenticatedMyProfileRouteImport } from './routes/_authenticated/myProfile'
import { Route as AuthenticatedLogoutRouteImport } from './routes/_authenticated/logout'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedInstrumentsListInstrumentsRouteImport } from './routes/_authenticated/instruments/listInstruments'
import { Route as AuthenticatedInstrumentsAddInstrumentRouteImport } from './routes/_authenticated/instruments/addInstrument'
import { Route as AuthenticatedVisitLogIdIndexRouteImport } from './routes/_authenticated/visitLog/$id/index'
import { Route as AuthenticatedInstrumentsIdIndexRouteImport } from './routes/_authenticated/instruments/$id/index'
import { Route as AuthenticatedDirectoryIdIndexRouteImport } from './routes/_authenticated/directory/$id/index'
import { Route as AuthenticatedAssistanceIdIndexRouteImport } from './routes/_authenticated/assistance/$id/index'
import { Route as AuthenticatedRequestsViewVisitListRequestAdminRouteImport } from './routes/_authenticated/requests/viewVisit/listRequestAdmin'
import { Route as AuthenticatedRequestsViewVacationListRequestsAdminRouteImport } from './routes/_authenticated/requests/viewVacation/listRequestsAdmin'
import { Route as AuthenticatedRequestsViewTravelListRequestRrhhRouteImport } from './routes/_authenticated/requests/viewTravel/listRequestRrhh'
import { Route as AuthenticatedRequestsViewLeaveListRequestRrhhRouteImport } from './routes/_authenticated/requests/viewLeave/listRequestRrhh'
import { Route as AuthenticatedRequestsViewCertifiesRequestsViewSupervisorRouteImport } from './routes/_authenticated/requests/viewCertifiesRequests/viewSupervisor'
import { Route as AuthenticatedRequestsViewCertifiesRequestsViewRrhhRouteImport } from './routes/_authenticated/requests/viewCertifiesRequests/viewRrhh'
import { Route as AuthenticatedRequestsViewCertifiesRequestsViewManagerRouteImport } from './routes/_authenticated/requests/viewCertifiesRequests/viewManager'
import { Route as AuthenticatedInstrumentsServiceReportAddServiceReportRouteImport } from './routes/_authenticated/instruments/serviceReport/addServiceReport'
import { Route as AuthenticatedInstrumentsIdEditRouteImport } from './routes/_authenticated/instruments/$id/edit'
import { Route as AuthenticatedDirectoryIdEditRouteImport } from './routes/_authenticated/directory/$id/edit'
import { Route as AuthenticatedAssistanceIdEditRouteImport } from './routes/_authenticated/assistance/$id/edit'
import { Route as AuthenticatedRequestsViewTravelIdIndexRouteImport } from './routes/_authenticated/requests/viewTravel/$id/index'
import { Route as AuthenticatedRequestsViewLeaveIdIndexRouteImport } from './routes/_authenticated/requests/viewLeave/$id/index'
import { Route as AuthenticatedRequestsIdVisitIndexRouteImport } from './routes/_authenticated/requests/$id/visit/index'
import { Route as AuthenticatedRequestsIdVacationsIndexRouteImport } from './routes/_authenticated/requests/$id/vacations/index'
import { Route as AuthenticatedRequestsIdTravelsIndexRouteImport } from './routes/_authenticated/requests/$id/travels/index'
import { Route as AuthenticatedRequestsIdLeavesIndexRouteImport } from './routes/_authenticated/requests/$id/leaves/index'
import { Route as AuthenticatedRequestsIdCertifiesIndexRouteImport } from './routes/_authenticated/requests/$id/certifies/index'
import { Route as AuthenticatedInstrumentsServiceReportIdIndexRouteImport } from './routes/_authenticated/instruments/serviceReport/$id/index'
import { Route as AuthenticatedInstrumentsReportIdIndexRouteImport } from './routes/_authenticated/instruments/report/$id/index'
import { Route as AuthenticatedVisitLogIdVisitIdAddVisitLogRouteImport } from './routes/_authenticated/visitLog/$id/$visitId/addVisitLog'
import { Route as AuthenticatedRequestsViewTravelIdEditTravelRouteImport } from './routes/_authenticated/requests/viewTravel/$id/editTravel'
import { Route as AuthenticatedRequestsViewTravelIdDetailTravelUserRouteImport } from './routes/_authenticated/requests/viewTravel/$id/detailTravelUser'
import { Route as AuthenticatedRequestsViewLeaveIdDetailLeaveUserRouteImport } from './routes/_authenticated/requests/viewLeave/$id/detailLeaveUser'
import { Route as AuthenticatedRequestsIdVisitAddRequestRouteImport } from './routes/_authenticated/requests/$id/visit/addRequest'
import { Route as AuthenticatedRequestsIdTravelsAddTravelRouteImport } from './routes/_authenticated/requests/$id/travels/addTravel'
import { Route as AuthenticatedInstrumentsServiceReportIdDraftIdRouteImport } from './routes/_authenticated/instruments/serviceReport/$id/$draftId'
import { Route as AuthenticatedRequestsIdTravelsTravelIdUpdateTravelRouteImport } from './routes/_authenticated/requests/$id/travels/$travelId/updateTravel'
import { Route as AuthenticatedInstrumentsServiceReportIdRevisionReportDocIdIndexRouteImport } from './routes/_authenticated/instruments/serviceReport/$id/revision/$reportDocId/index'

const AuthenticatedEventsCalendarLazyRouteImport = createFileRoute(
  '/_authenticated/eventsCalendar',
)()
const AuthenticatedActivityLazyRouteImport = createFileRoute(
  '/_authenticated/activity',
)()
const AuthenticatedRequestsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/requests/',
)()
const AuthenticatedHolidaysIndexLazyRouteImport = createFileRoute(
  '/_authenticated/holidays/',
)()
const AuthenticatedDirectoryIndexLazyRouteImport = createFileRoute(
  '/_authenticated/directory/',
)()
const AuthenticatedAssistanceIndexLazyRouteImport = createFileRoute(
  '/_authenticated/assistance/',
)()

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedEventsCalendarLazyRoute =
  AuthenticatedEventsCalendarLazyRouteImport.update({
    id: '/eventsCalendar',
    path: '/eventsCalendar',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/eventsCalendar.lazy').then((d) => d.Route),
  )
const AuthenticatedActivityLazyRoute =
  AuthenticatedActivityLazyRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/activity.lazy').then((d) => d.Route),
  )
const AuthenticatedWorkLogRoute = AuthenticatedWorkLogRouteImport.update({
  id: '/workLog',
  path: '/workLog',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUserRoute = AuthenticatedUserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUnauthorizedRoute =
  AuthenticatedUnauthorizedRouteImport.update({
    id: '/unauthorized',
    path: '/unauthorized',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUbicationRoute = AuthenticatedUbicationRouteImport.update({
  id: '/ubication',
  path: '/ubication',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportRoute = AuthenticatedReportRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNoteRoute = AuthenticatedNoteRouteImport.update({
  id: '/note',
  path: '/note',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNewCollaboratorRoute =
  AuthenticatedNewCollaboratorRouteImport.update({
    id: '/newCollaborator',
    path: '/newCollaborator',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMyProfileRoute = AuthenticatedMyProfileRouteImport.update({
  id: '/myProfile',
  path: '/myProfile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLogoutRoute = AuthenticatedLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRequestsIndexLazyRoute =
  AuthenticatedRequestsIndexLazyRouteImport.update({
    id: '/requests/',
    path: '/requests/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/requests/index.lazy').then((d) => d.Route),
  )
const AuthenticatedHolidaysIndexLazyRoute =
  AuthenticatedHolidaysIndexLazyRouteImport.update({
    id: '/holidays/',
    path: '/holidays/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/holidays/index.lazy').then((d) => d.Route),
  )
const AuthenticatedDirectoryIndexLazyRoute =
  AuthenticatedDirectoryIndexLazyRouteImport.update({
    id: '/directory/',
    path: '/directory/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/directory/index.lazy').then((d) => d.Route),
  )
const AuthenticatedAssistanceIndexLazyRoute =
  AuthenticatedAssistanceIndexLazyRouteImport.update({
    id: '/assistance/',
    path: '/assistance/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/assistance/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedInstrumentsListInstrumentsRoute =
  AuthenticatedInstrumentsListInstrumentsRouteImport.update({
    id: '/instruments/listInstruments',
    path: '/instruments/listInstruments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInstrumentsAddInstrumentRoute =
  AuthenticatedInstrumentsAddInstrumentRouteImport.update({
    id: '/instruments/addInstrument',
    path: '/instruments/addInstrument',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVisitLogIdIndexRoute =
  AuthenticatedVisitLogIdIndexRouteImport.update({
    id: '/visitLog/$id/',
    path: '/visitLog/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInstrumentsIdIndexRoute =
  AuthenticatedInstrumentsIdIndexRouteImport.update({
    id: '/instruments/$id/',
    path: '/instruments/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDirectoryIdIndexRoute =
  AuthenticatedDirectoryIdIndexRouteImport.update({
    id: '/directory/$id/',
    path: '/directory/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAssistanceIdIndexRoute =
  AuthenticatedAssistanceIdIndexRouteImport.update({
    id: '/assistance/$id/',
    path: '/assistance/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsViewVisitListRequestAdminRoute =
  AuthenticatedRequestsViewVisitListRequestAdminRouteImport.update({
    id: '/requests/viewVisit/listRequestAdmin',
    path: '/requests/viewVisit/listRequestAdmin',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsViewVacationListRequestsAdminRoute =
  AuthenticatedRequestsViewVacationListRequestsAdminRouteImport.update({
    id: '/requests/viewVacation/listRequestsAdmin',
    path: '/requests/viewVacation/listRequestsAdmin',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsViewTravelListRequestRrhhRoute =
  AuthenticatedRequestsViewTravelListRequestRrhhRouteImport.update({
    id: '/requests/viewTravel/listRequestRrhh',
    path: '/requests/viewTravel/listRequestRrhh',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsViewLeaveListRequestRrhhRoute =
  AuthenticatedRequestsViewLeaveListRequestRrhhRouteImport.update({
    id: '/requests/viewLeave/listRequestRrhh',
    path: '/requests/viewLeave/listRequestRrhh',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsViewCertifiesRequestsViewSupervisorRoute =
  AuthenticatedRequestsViewCertifiesRequestsViewSupervisorRouteImport.update({
    id: '/requests/viewCertifiesRequests/viewSupervisor',
    path: '/requests/viewCertifiesRequests/viewSupervisor',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsViewCertifiesRequestsViewRrhhRoute =
  AuthenticatedRequestsViewCertifiesRequestsViewRrhhRouteImport.update({
    id: '/requests/viewCertifiesRequests/viewRrhh',
    path: '/requests/viewCertifiesRequests/viewRrhh',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsViewCertifiesRequestsViewManagerRoute =
  AuthenticatedRequestsViewCertifiesRequestsViewManagerRouteImport.update({
    id: '/requests/viewCertifiesRequests/viewManager',
    path: '/requests/viewCertifiesRequests/viewManager',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInstrumentsServiceReportAddServiceReportRoute =
  AuthenticatedInstrumentsServiceReportAddServiceReportRouteImport.update({
    id: '/instruments/serviceReport/addServiceReport',
    path: '/instruments/serviceReport/addServiceReport',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInstrumentsIdEditRoute =
  AuthenticatedInstrumentsIdEditRouteImport.update({
    id: '/instruments/$id/edit',
    path: '/instruments/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDirectoryIdEditRoute =
  AuthenticatedDirectoryIdEditRouteImport.update({
    id: '/directory/$id/edit',
    path: '/directory/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAssistanceIdEditRoute =
  AuthenticatedAssistanceIdEditRouteImport.update({
    id: '/assistance/$id/edit',
    path: '/assistance/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsViewTravelIdIndexRoute =
  AuthenticatedRequestsViewTravelIdIndexRouteImport.update({
    id: '/requests/viewTravel/$id/',
    path: '/requests/viewTravel/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsViewLeaveIdIndexRoute =
  AuthenticatedRequestsViewLeaveIdIndexRouteImport.update({
    id: '/requests/viewLeave/$id/',
    path: '/requests/viewLeave/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsIdVisitIndexRoute =
  AuthenticatedRequestsIdVisitIndexRouteImport.update({
    id: '/requests/$id/visit/',
    path: '/requests/$id/visit/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsIdVacationsIndexRoute =
  AuthenticatedRequestsIdVacationsIndexRouteImport.update({
    id: '/requests/$id/vacations/',
    path: '/requests/$id/vacations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsIdTravelsIndexRoute =
  AuthenticatedRequestsIdTravelsIndexRouteImport.update({
    id: '/requests/$id/travels/',
    path: '/requests/$id/travels/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsIdLeavesIndexRoute =
  AuthenticatedRequestsIdLeavesIndexRouteImport.update({
    id: '/requests/$id/leaves/',
    path: '/requests/$id/leaves/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsIdCertifiesIndexRoute =
  AuthenticatedRequestsIdCertifiesIndexRouteImport.update({
    id: '/requests/$id/certifies/',
    path: '/requests/$id/certifies/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInstrumentsServiceReportIdIndexRoute =
  AuthenticatedInstrumentsServiceReportIdIndexRouteImport.update({
    id: '/instruments/serviceReport/$id/',
    path: '/instruments/serviceReport/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInstrumentsReportIdIndexRoute =
  AuthenticatedInstrumentsReportIdIndexRouteImport.update({
    id: '/instruments/report/$id/',
    path: '/instruments/report/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVisitLogIdVisitIdAddVisitLogRoute =
  AuthenticatedVisitLogIdVisitIdAddVisitLogRouteImport.update({
    id: '/visitLog/$id/$visitId/addVisitLog',
    path: '/visitLog/$id/$visitId/addVisitLog',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsViewTravelIdEditTravelRoute =
  AuthenticatedRequestsViewTravelIdEditTravelRouteImport.update({
    id: '/requests/viewTravel/$id/editTravel',
    path: '/requests/viewTravel/$id/editTravel',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsViewTravelIdDetailTravelUserRoute =
  AuthenticatedRequestsViewTravelIdDetailTravelUserRouteImport.update({
    id: '/requests/viewTravel/$id/detailTravelUser',
    path: '/requests/viewTravel/$id/detailTravelUser',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsViewLeaveIdDetailLeaveUserRoute =
  AuthenticatedRequestsViewLeaveIdDetailLeaveUserRouteImport.update({
    id: '/requests/viewLeave/$id/detailLeaveUser',
    path: '/requests/viewLeave/$id/detailLeaveUser',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsIdVisitAddRequestRoute =
  AuthenticatedRequestsIdVisitAddRequestRouteImport.update({
    id: '/requests/$id/visit/addRequest',
    path: '/requests/$id/visit/addRequest',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsIdTravelsAddTravelRoute =
  AuthenticatedRequestsIdTravelsAddTravelRouteImport.update({
    id: '/requests/$id/travels/addTravel',
    path: '/requests/$id/travels/addTravel',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInstrumentsServiceReportIdDraftIdRoute =
  AuthenticatedInstrumentsServiceReportIdDraftIdRouteImport.update({
    id: '/instruments/serviceReport/$id/$draftId',
    path: '/instruments/serviceReport/$id/$draftId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRequestsIdTravelsTravelIdUpdateTravelRoute =
  AuthenticatedRequestsIdTravelsTravelIdUpdateTravelRouteImport.update({
    id: '/requests/$id/travels/$travelId/updateTravel',
    path: '/requests/$id/travels/$travelId/updateTravel',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInstrumentsServiceReportIdRevisionReportDocIdIndexRoute =
  AuthenticatedInstrumentsServiceReportIdRevisionReportDocIdIndexRouteImport.update(
    {
      id: '/instruments/serviceReport/$id/revision/$reportDocId/',
      path: '/instruments/serviceReport/$id/revision/$reportDocId/',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/logout': typeof AuthenticatedLogoutRoute
  '/myProfile': typeof AuthenticatedMyProfileRoute
  '/newCollaborator': typeof AuthenticatedNewCollaboratorRoute
  '/note': typeof AuthenticatedNoteRoute
  '/report': typeof AuthenticatedReportRoute
  '/ubication': typeof AuthenticatedUbicationRoute
  '/unauthorized': typeof AuthenticatedUnauthorizedRoute
  '/user': typeof AuthenticatedUserRoute
  '/workLog': typeof AuthenticatedWorkLogRoute
  '/activity': typeof AuthenticatedActivityLazyRoute
  '/eventsCalendar': typeof AuthenticatedEventsCalendarLazyRoute
  '/instruments/addInstrument': typeof AuthenticatedInstrumentsAddInstrumentRoute
  '/instruments/listInstruments': typeof AuthenticatedInstrumentsListInstrumentsRoute
  '/assistance/': typeof AuthenticatedAssistanceIndexLazyRoute
  '/directory/': typeof AuthenticatedDirectoryIndexLazyRoute
  '/holidays/': typeof AuthenticatedHolidaysIndexLazyRoute
  '/requests/': typeof AuthenticatedRequestsIndexLazyRoute
  '/assistance/$id/edit': typeof AuthenticatedAssistanceIdEditRoute
  '/directory/$id/edit': typeof AuthenticatedDirectoryIdEditRoute
  '/instruments/$id/edit': typeof AuthenticatedInstrumentsIdEditRoute
  '/instruments/serviceReport/addServiceReport': typeof AuthenticatedInstrumentsServiceReportAddServiceReportRoute
  '/requests/viewCertifiesRequests/viewManager': typeof AuthenticatedRequestsViewCertifiesRequestsViewManagerRoute
  '/requests/viewCertifiesRequests/viewRrhh': typeof AuthenticatedRequestsViewCertifiesRequestsViewRrhhRoute
  '/requests/viewCertifiesRequests/viewSupervisor': typeof AuthenticatedRequestsViewCertifiesRequestsViewSupervisorRoute
  '/requests/viewLeave/listRequestRrhh': typeof AuthenticatedRequestsViewLeaveListRequestRrhhRoute
  '/requests/viewTravel/listRequestRrhh': typeof AuthenticatedRequestsViewTravelListRequestRrhhRoute
  '/requests/viewVacation/listRequestsAdmin': typeof AuthenticatedRequestsViewVacationListRequestsAdminRoute
  '/requests/viewVisit/listRequestAdmin': typeof AuthenticatedRequestsViewVisitListRequestAdminRoute
  '/assistance/$id/': typeof AuthenticatedAssistanceIdIndexRoute
  '/directory/$id/': typeof AuthenticatedDirectoryIdIndexRoute
  '/instruments/$id/': typeof AuthenticatedInstrumentsIdIndexRoute
  '/visitLog/$id/': typeof AuthenticatedVisitLogIdIndexRoute
  '/instruments/serviceReport/$id/$draftId': typeof AuthenticatedInstrumentsServiceReportIdDraftIdRoute
  '/requests/$id/travels/addTravel': typeof AuthenticatedRequestsIdTravelsAddTravelRoute
  '/requests/$id/visit/addRequest': typeof AuthenticatedRequestsIdVisitAddRequestRoute
  '/requests/viewLeave/$id/detailLeaveUser': typeof AuthenticatedRequestsViewLeaveIdDetailLeaveUserRoute
  '/requests/viewTravel/$id/detailTravelUser': typeof AuthenticatedRequestsViewTravelIdDetailTravelUserRoute
  '/requests/viewTravel/$id/editTravel': typeof AuthenticatedRequestsViewTravelIdEditTravelRoute
  '/visitLog/$id/$visitId/addVisitLog': typeof AuthenticatedVisitLogIdVisitIdAddVisitLogRoute
  '/instruments/report/$id/': typeof AuthenticatedInstrumentsReportIdIndexRoute
  '/instruments/serviceReport/$id/': typeof AuthenticatedInstrumentsServiceReportIdIndexRoute
  '/requests/$id/certifies/': typeof AuthenticatedRequestsIdCertifiesIndexRoute
  '/requests/$id/leaves/': typeof AuthenticatedRequestsIdLeavesIndexRoute
  '/requests/$id/travels/': typeof AuthenticatedRequestsIdTravelsIndexRoute
  '/requests/$id/vacations/': typeof AuthenticatedRequestsIdVacationsIndexRoute
  '/requests/$id/visit/': typeof AuthenticatedRequestsIdVisitIndexRoute
  '/requests/viewLeave/$id/': typeof AuthenticatedRequestsViewLeaveIdIndexRoute
  '/requests/viewTravel/$id/': typeof AuthenticatedRequestsViewTravelIdIndexRoute
  '/requests/$id/travels/$travelId/updateTravel': typeof AuthenticatedRequestsIdTravelsTravelIdUpdateTravelRoute
  '/instruments/serviceReport/$id/revision/$reportDocId/': typeof AuthenticatedInstrumentsServiceReportIdRevisionReportDocIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/logout': typeof AuthenticatedLogoutRoute
  '/myProfile': typeof AuthenticatedMyProfileRoute
  '/newCollaborator': typeof AuthenticatedNewCollaboratorRoute
  '/note': typeof AuthenticatedNoteRoute
  '/report': typeof AuthenticatedReportRoute
  '/ubication': typeof AuthenticatedUbicationRoute
  '/unauthorized': typeof AuthenticatedUnauthorizedRoute
  '/user': typeof AuthenticatedUserRoute
  '/workLog': typeof AuthenticatedWorkLogRoute
  '/activity': typeof AuthenticatedActivityLazyRoute
  '/eventsCalendar': typeof AuthenticatedEventsCalendarLazyRoute
  '/instruments/addInstrument': typeof AuthenticatedInstrumentsAddInstrumentRoute
  '/instruments/listInstruments': typeof AuthenticatedInstrumentsListInstrumentsRoute
  '/assistance': typeof AuthenticatedAssistanceIndexLazyRoute
  '/directory': typeof AuthenticatedDirectoryIndexLazyRoute
  '/holidays': typeof AuthenticatedHolidaysIndexLazyRoute
  '/requests': typeof AuthenticatedRequestsIndexLazyRoute
  '/assistance/$id/edit': typeof AuthenticatedAssistanceIdEditRoute
  '/directory/$id/edit': typeof AuthenticatedDirectoryIdEditRoute
  '/instruments/$id/edit': typeof AuthenticatedInstrumentsIdEditRoute
  '/instruments/serviceReport/addServiceReport': typeof AuthenticatedInstrumentsServiceReportAddServiceReportRoute
  '/requests/viewCertifiesRequests/viewManager': typeof AuthenticatedRequestsViewCertifiesRequestsViewManagerRoute
  '/requests/viewCertifiesRequests/viewRrhh': typeof AuthenticatedRequestsViewCertifiesRequestsViewRrhhRoute
  '/requests/viewCertifiesRequests/viewSupervisor': typeof AuthenticatedRequestsViewCertifiesRequestsViewSupervisorRoute
  '/requests/viewLeave/listRequestRrhh': typeof AuthenticatedRequestsViewLeaveListRequestRrhhRoute
  '/requests/viewTravel/listRequestRrhh': typeof AuthenticatedRequestsViewTravelListRequestRrhhRoute
  '/requests/viewVacation/listRequestsAdmin': typeof AuthenticatedRequestsViewVacationListRequestsAdminRoute
  '/requests/viewVisit/listRequestAdmin': typeof AuthenticatedRequestsViewVisitListRequestAdminRoute
  '/assistance/$id': typeof AuthenticatedAssistanceIdIndexRoute
  '/directory/$id': typeof AuthenticatedDirectoryIdIndexRoute
  '/instruments/$id': typeof AuthenticatedInstrumentsIdIndexRoute
  '/visitLog/$id': typeof AuthenticatedVisitLogIdIndexRoute
  '/instruments/serviceReport/$id/$draftId': typeof AuthenticatedInstrumentsServiceReportIdDraftIdRoute
  '/requests/$id/travels/addTravel': typeof AuthenticatedRequestsIdTravelsAddTravelRoute
  '/requests/$id/visit/addRequest': typeof AuthenticatedRequestsIdVisitAddRequestRoute
  '/requests/viewLeave/$id/detailLeaveUser': typeof AuthenticatedRequestsViewLeaveIdDetailLeaveUserRoute
  '/requests/viewTravel/$id/detailTravelUser': typeof AuthenticatedRequestsViewTravelIdDetailTravelUserRoute
  '/requests/viewTravel/$id/editTravel': typeof AuthenticatedRequestsViewTravelIdEditTravelRoute
  '/visitLog/$id/$visitId/addVisitLog': typeof AuthenticatedVisitLogIdVisitIdAddVisitLogRoute
  '/instruments/report/$id': typeof AuthenticatedInstrumentsReportIdIndexRoute
  '/instruments/serviceReport/$id': typeof AuthenticatedInstrumentsServiceReportIdIndexRoute
  '/requests/$id/certifies': typeof AuthenticatedRequestsIdCertifiesIndexRoute
  '/requests/$id/leaves': typeof AuthenticatedRequestsIdLeavesIndexRoute
  '/requests/$id/travels': typeof AuthenticatedRequestsIdTravelsIndexRoute
  '/requests/$id/vacations': typeof AuthenticatedRequestsIdVacationsIndexRoute
  '/requests/$id/visit': typeof AuthenticatedRequestsIdVisitIndexRoute
  '/requests/viewLeave/$id': typeof AuthenticatedRequestsViewLeaveIdIndexRoute
  '/requests/viewTravel/$id': typeof AuthenticatedRequestsViewTravelIdIndexRoute
  '/requests/$id/travels/$travelId/updateTravel': typeof AuthenticatedRequestsIdTravelsTravelIdUpdateTravelRoute
  '/instruments/serviceReport/$id/revision/$reportDocId': typeof AuthenticatedInstrumentsServiceReportIdRevisionReportDocIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/logout': typeof AuthenticatedLogoutRoute
  '/_authenticated/myProfile': typeof AuthenticatedMyProfileRoute
  '/_authenticated/newCollaborator': typeof AuthenticatedNewCollaboratorRoute
  '/_authenticated/note': typeof AuthenticatedNoteRoute
  '/_authenticated/report': typeof AuthenticatedReportRoute
  '/_authenticated/ubication': typeof AuthenticatedUbicationRoute
  '/_authenticated/unauthorized': typeof AuthenticatedUnauthorizedRoute
  '/_authenticated/user': typeof AuthenticatedUserRoute
  '/_authenticated/workLog': typeof AuthenticatedWorkLogRoute
  '/_authenticated/activity': typeof AuthenticatedActivityLazyRoute
  '/_authenticated/eventsCalendar': typeof AuthenticatedEventsCalendarLazyRoute
  '/_authenticated/instruments/addInstrument': typeof AuthenticatedInstrumentsAddInstrumentRoute
  '/_authenticated/instruments/listInstruments': typeof AuthenticatedInstrumentsListInstrumentsRoute
  '/_authenticated/assistance/': typeof AuthenticatedAssistanceIndexLazyRoute
  '/_authenticated/directory/': typeof AuthenticatedDirectoryIndexLazyRoute
  '/_authenticated/holidays/': typeof AuthenticatedHolidaysIndexLazyRoute
  '/_authenticated/requests/': typeof AuthenticatedRequestsIndexLazyRoute
  '/_authenticated/assistance/$id/edit': typeof AuthenticatedAssistanceIdEditRoute
  '/_authenticated/directory/$id/edit': typeof AuthenticatedDirectoryIdEditRoute
  '/_authenticated/instruments/$id/edit': typeof AuthenticatedInstrumentsIdEditRoute
  '/_authenticated/instruments/serviceReport/addServiceReport': typeof AuthenticatedInstrumentsServiceReportAddServiceReportRoute
  '/_authenticated/requests/viewCertifiesRequests/viewManager': typeof AuthenticatedRequestsViewCertifiesRequestsViewManagerRoute
  '/_authenticated/requests/viewCertifiesRequests/viewRrhh': typeof AuthenticatedRequestsViewCertifiesRequestsViewRrhhRoute
  '/_authenticated/requests/viewCertifiesRequests/viewSupervisor': typeof AuthenticatedRequestsViewCertifiesRequestsViewSupervisorRoute
  '/_authenticated/requests/viewLeave/listRequestRrhh': typeof AuthenticatedRequestsViewLeaveListRequestRrhhRoute
  '/_authenticated/requests/viewTravel/listRequestRrhh': typeof AuthenticatedRequestsViewTravelListRequestRrhhRoute
  '/_authenticated/requests/viewVacation/listRequestsAdmin': typeof AuthenticatedRequestsViewVacationListRequestsAdminRoute
  '/_authenticated/requests/viewVisit/listRequestAdmin': typeof AuthenticatedRequestsViewVisitListRequestAdminRoute
  '/_authenticated/assistance/$id/': typeof AuthenticatedAssistanceIdIndexRoute
  '/_authenticated/directory/$id/': typeof AuthenticatedDirectoryIdIndexRoute
  '/_authenticated/instruments/$id/': typeof AuthenticatedInstrumentsIdIndexRoute
  '/_authenticated/visitLog/$id/': typeof AuthenticatedVisitLogIdIndexRoute
  '/_authenticated/instruments/serviceReport/$id/$draftId': typeof AuthenticatedInstrumentsServiceReportIdDraftIdRoute
  '/_authenticated/requests/$id/travels/addTravel': typeof AuthenticatedRequestsIdTravelsAddTravelRoute
  '/_authenticated/requests/$id/visit/addRequest': typeof AuthenticatedRequestsIdVisitAddRequestRoute
  '/_authenticated/requests/viewLeave/$id/detailLeaveUser': typeof AuthenticatedRequestsViewLeaveIdDetailLeaveUserRoute
  '/_authenticated/requests/viewTravel/$id/detailTravelUser': typeof AuthenticatedRequestsViewTravelIdDetailTravelUserRoute
  '/_authenticated/requests/viewTravel/$id/editTravel': typeof AuthenticatedRequestsViewTravelIdEditTravelRoute
  '/_authenticated/visitLog/$id/$visitId/addVisitLog': typeof AuthenticatedVisitLogIdVisitIdAddVisitLogRoute
  '/_authenticated/instruments/report/$id/': typeof AuthenticatedInstrumentsReportIdIndexRoute
  '/_authenticated/instruments/serviceReport/$id/': typeof AuthenticatedInstrumentsServiceReportIdIndexRoute
  '/_authenticated/requests/$id/certifies/': typeof AuthenticatedRequestsIdCertifiesIndexRoute
  '/_authenticated/requests/$id/leaves/': typeof AuthenticatedRequestsIdLeavesIndexRoute
  '/_authenticated/requests/$id/travels/': typeof AuthenticatedRequestsIdTravelsIndexRoute
  '/_authenticated/requests/$id/vacations/': typeof AuthenticatedRequestsIdVacationsIndexRoute
  '/_authenticated/requests/$id/visit/': typeof AuthenticatedRequestsIdVisitIndexRoute
  '/_authenticated/requests/viewLeave/$id/': typeof AuthenticatedRequestsViewLeaveIdIndexRoute
  '/_authenticated/requests/viewTravel/$id/': typeof AuthenticatedRequestsViewTravelIdIndexRoute
  '/_authenticated/requests/$id/travels/$travelId/updateTravel': typeof AuthenticatedRequestsIdTravelsTravelIdUpdateTravelRoute
  '/_authenticated/instruments/serviceReport/$id/revision/$reportDocId/': typeof AuthenticatedInstrumentsServiceReportIdRevisionReportDocIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dashboard'
    | '/logout'
    | '/myProfile'
    | '/newCollaborator'
    | '/note'
    | '/report'
    | '/ubication'
    | '/unauthorized'
    | '/user'
    | '/workLog'
    | '/activity'
    | '/eventsCalendar'
    | '/instruments/addInstrument'
    | '/instruments/listInstruments'
    | '/assistance/'
    | '/directory/'
    | '/holidays/'
    | '/requests/'
    | '/assistance/$id/edit'
    | '/directory/$id/edit'
    | '/instruments/$id/edit'
    | '/instruments/serviceReport/addServiceReport'
    | '/requests/viewCertifiesRequests/viewManager'
    | '/requests/viewCertifiesRequests/viewRrhh'
    | '/requests/viewCertifiesRequests/viewSupervisor'
    | '/requests/viewLeave/listRequestRrhh'
    | '/requests/viewTravel/listRequestRrhh'
    | '/requests/viewVacation/listRequestsAdmin'
    | '/requests/viewVisit/listRequestAdmin'
    | '/assistance/$id/'
    | '/directory/$id/'
    | '/instruments/$id/'
    | '/visitLog/$id/'
    | '/instruments/serviceReport/$id/$draftId'
    | '/requests/$id/travels/addTravel'
    | '/requests/$id/visit/addRequest'
    | '/requests/viewLeave/$id/detailLeaveUser'
    | '/requests/viewTravel/$id/detailTravelUser'
    | '/requests/viewTravel/$id/editTravel'
    | '/visitLog/$id/$visitId/addVisitLog'
    | '/instruments/report/$id/'
    | '/instruments/serviceReport/$id/'
    | '/requests/$id/certifies/'
    | '/requests/$id/leaves/'
    | '/requests/$id/travels/'
    | '/requests/$id/vacations/'
    | '/requests/$id/visit/'
    | '/requests/viewLeave/$id/'
    | '/requests/viewTravel/$id/'
    | '/requests/$id/travels/$travelId/updateTravel'
    | '/instruments/serviceReport/$id/revision/$reportDocId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard'
    | '/logout'
    | '/myProfile'
    | '/newCollaborator'
    | '/note'
    | '/report'
    | '/ubication'
    | '/unauthorized'
    | '/user'
    | '/workLog'
    | '/activity'
    | '/eventsCalendar'
    | '/instruments/addInstrument'
    | '/instruments/listInstruments'
    | '/assistance'
    | '/directory'
    | '/holidays'
    | '/requests'
    | '/assistance/$id/edit'
    | '/directory/$id/edit'
    | '/instruments/$id/edit'
    | '/instruments/serviceReport/addServiceReport'
    | '/requests/viewCertifiesRequests/viewManager'
    | '/requests/viewCertifiesRequests/viewRrhh'
    | '/requests/viewCertifiesRequests/viewSupervisor'
    | '/requests/viewLeave/listRequestRrhh'
    | '/requests/viewTravel/listRequestRrhh'
    | '/requests/viewVacation/listRequestsAdmin'
    | '/requests/viewVisit/listRequestAdmin'
    | '/assistance/$id'
    | '/directory/$id'
    | '/instruments/$id'
    | '/visitLog/$id'
    | '/instruments/serviceReport/$id/$draftId'
    | '/requests/$id/travels/addTravel'
    | '/requests/$id/visit/addRequest'
    | '/requests/viewLeave/$id/detailLeaveUser'
    | '/requests/viewTravel/$id/detailTravelUser'
    | '/requests/viewTravel/$id/editTravel'
    | '/visitLog/$id/$visitId/addVisitLog'
    | '/instruments/report/$id'
    | '/instruments/serviceReport/$id'
    | '/requests/$id/certifies'
    | '/requests/$id/leaves'
    | '/requests/$id/travels'
    | '/requests/$id/vacations'
    | '/requests/$id/visit'
    | '/requests/viewLeave/$id'
    | '/requests/viewTravel/$id'
    | '/requests/$id/travels/$travelId/updateTravel'
    | '/instruments/serviceReport/$id/revision/$reportDocId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/dashboard'
    | '/_authenticated/logout'
    | '/_authenticated/myProfile'
    | '/_authenticated/newCollaborator'
    | '/_authenticated/note'
    | '/_authenticated/report'
    | '/_authenticated/ubication'
    | '/_authenticated/unauthorized'
    | '/_authenticated/user'
    | '/_authenticated/workLog'
    | '/_authenticated/activity'
    | '/_authenticated/eventsCalendar'
    | '/_authenticated/instruments/addInstrument'
    | '/_authenticated/instruments/listInstruments'
    | '/_authenticated/assistance/'
    | '/_authenticated/directory/'
    | '/_authenticated/holidays/'
    | '/_authenticated/requests/'
    | '/_authenticated/assistance/$id/edit'
    | '/_authenticated/directory/$id/edit'
    | '/_authenticated/instruments/$id/edit'
    | '/_authenticated/instruments/serviceReport/addServiceReport'
    | '/_authenticated/requests/viewCertifiesRequests/viewManager'
    | '/_authenticated/requests/viewCertifiesRequests/viewRrhh'
    | '/_authenticated/requests/viewCertifiesRequests/viewSupervisor'
    | '/_authenticated/requests/viewLeave/listRequestRrhh'
    | '/_authenticated/requests/viewTravel/listRequestRrhh'
    | '/_authenticated/requests/viewVacation/listRequestsAdmin'
    | '/_authenticated/requests/viewVisit/listRequestAdmin'
    | '/_authenticated/assistance/$id/'
    | '/_authenticated/directory/$id/'
    | '/_authenticated/instruments/$id/'
    | '/_authenticated/visitLog/$id/'
    | '/_authenticated/instruments/serviceReport/$id/$draftId'
    | '/_authenticated/requests/$id/travels/addTravel'
    | '/_authenticated/requests/$id/visit/addRequest'
    | '/_authenticated/requests/viewLeave/$id/detailLeaveUser'
    | '/_authenticated/requests/viewTravel/$id/detailTravelUser'
    | '/_authenticated/requests/viewTravel/$id/editTravel'
    | '/_authenticated/visitLog/$id/$visitId/addVisitLog'
    | '/_authenticated/instruments/report/$id/'
    | '/_authenticated/instruments/serviceReport/$id/'
    | '/_authenticated/requests/$id/certifies/'
    | '/_authenticated/requests/$id/leaves/'
    | '/_authenticated/requests/$id/travels/'
    | '/_authenticated/requests/$id/vacations/'
    | '/_authenticated/requests/$id/visit/'
    | '/_authenticated/requests/viewLeave/$id/'
    | '/_authenticated/requests/viewTravel/$id/'
    | '/_authenticated/requests/$id/travels/$travelId/updateTravel'
    | '/_authenticated/instruments/serviceReport/$id/revision/$reportDocId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/eventsCalendar': {
      id: '/_authenticated/eventsCalendar'
      path: '/eventsCalendar'
      fullPath: '/eventsCalendar'
      preLoaderRoute: typeof AuthenticatedEventsCalendarLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/activity': {
      id: '/_authenticated/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AuthenticatedActivityLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/workLog': {
      id: '/_authenticated/workLog'
      path: '/workLog'
      fullPath: '/workLog'
      preLoaderRoute: typeof AuthenticatedWorkLogRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/user': {
      id: '/_authenticated/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof AuthenticatedUserRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/unauthorized': {
      id: '/_authenticated/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof AuthenticatedUnauthorizedRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ubication': {
      id: '/_authenticated/ubication'
      path: '/ubication'
      fullPath: '/ubication'
      preLoaderRoute: typeof AuthenticatedUbicationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/report': {
      id: '/_authenticated/report'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof AuthenticatedReportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/note': {
      id: '/_authenticated/note'
      path: '/note'
      fullPath: '/note'
      preLoaderRoute: typeof AuthenticatedNoteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/newCollaborator': {
      id: '/_authenticated/newCollaborator'
      path: '/newCollaborator'
      fullPath: '/newCollaborator'
      preLoaderRoute: typeof AuthenticatedNewCollaboratorRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/myProfile': {
      id: '/_authenticated/myProfile'
      path: '/myProfile'
      fullPath: '/myProfile'
      preLoaderRoute: typeof AuthenticatedMyProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/logout': {
      id: '/_authenticated/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AuthenticatedLogoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/': {
      id: '/_authenticated/requests/'
      path: '/requests'
      fullPath: '/requests/'
      preLoaderRoute: typeof AuthenticatedRequestsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/holidays/': {
      id: '/_authenticated/holidays/'
      path: '/holidays'
      fullPath: '/holidays/'
      preLoaderRoute: typeof AuthenticatedHolidaysIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/directory/': {
      id: '/_authenticated/directory/'
      path: '/directory'
      fullPath: '/directory/'
      preLoaderRoute: typeof AuthenticatedDirectoryIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assistance/': {
      id: '/_authenticated/assistance/'
      path: '/assistance'
      fullPath: '/assistance/'
      preLoaderRoute: typeof AuthenticatedAssistanceIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/instruments/listInstruments': {
      id: '/_authenticated/instruments/listInstruments'
      path: '/instruments/listInstruments'
      fullPath: '/instruments/listInstruments'
      preLoaderRoute: typeof AuthenticatedInstrumentsListInstrumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/instruments/addInstrument': {
      id: '/_authenticated/instruments/addInstrument'
      path: '/instruments/addInstrument'
      fullPath: '/instruments/addInstrument'
      preLoaderRoute: typeof AuthenticatedInstrumentsAddInstrumentRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/visitLog/$id/': {
      id: '/_authenticated/visitLog/$id/'
      path: '/visitLog/$id'
      fullPath: '/visitLog/$id/'
      preLoaderRoute: typeof AuthenticatedVisitLogIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/instruments/$id/': {
      id: '/_authenticated/instruments/$id/'
      path: '/instruments/$id'
      fullPath: '/instruments/$id/'
      preLoaderRoute: typeof AuthenticatedInstrumentsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/directory/$id/': {
      id: '/_authenticated/directory/$id/'
      path: '/directory/$id'
      fullPath: '/directory/$id/'
      preLoaderRoute: typeof AuthenticatedDirectoryIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assistance/$id/': {
      id: '/_authenticated/assistance/$id/'
      path: '/assistance/$id'
      fullPath: '/assistance/$id/'
      preLoaderRoute: typeof AuthenticatedAssistanceIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/viewVisit/listRequestAdmin': {
      id: '/_authenticated/requests/viewVisit/listRequestAdmin'
      path: '/requests/viewVisit/listRequestAdmin'
      fullPath: '/requests/viewVisit/listRequestAdmin'
      preLoaderRoute: typeof AuthenticatedRequestsViewVisitListRequestAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/viewVacation/listRequestsAdmin': {
      id: '/_authenticated/requests/viewVacation/listRequestsAdmin'
      path: '/requests/viewVacation/listRequestsAdmin'
      fullPath: '/requests/viewVacation/listRequestsAdmin'
      preLoaderRoute: typeof AuthenticatedRequestsViewVacationListRequestsAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/viewTravel/listRequestRrhh': {
      id: '/_authenticated/requests/viewTravel/listRequestRrhh'
      path: '/requests/viewTravel/listRequestRrhh'
      fullPath: '/requests/viewTravel/listRequestRrhh'
      preLoaderRoute: typeof AuthenticatedRequestsViewTravelListRequestRrhhRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/viewLeave/listRequestRrhh': {
      id: '/_authenticated/requests/viewLeave/listRequestRrhh'
      path: '/requests/viewLeave/listRequestRrhh'
      fullPath: '/requests/viewLeave/listRequestRrhh'
      preLoaderRoute: typeof AuthenticatedRequestsViewLeaveListRequestRrhhRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/viewCertifiesRequests/viewSupervisor': {
      id: '/_authenticated/requests/viewCertifiesRequests/viewSupervisor'
      path: '/requests/viewCertifiesRequests/viewSupervisor'
      fullPath: '/requests/viewCertifiesRequests/viewSupervisor'
      preLoaderRoute: typeof AuthenticatedRequestsViewCertifiesRequestsViewSupervisorRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/viewCertifiesRequests/viewRrhh': {
      id: '/_authenticated/requests/viewCertifiesRequests/viewRrhh'
      path: '/requests/viewCertifiesRequests/viewRrhh'
      fullPath: '/requests/viewCertifiesRequests/viewRrhh'
      preLoaderRoute: typeof AuthenticatedRequestsViewCertifiesRequestsViewRrhhRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/viewCertifiesRequests/viewManager': {
      id: '/_authenticated/requests/viewCertifiesRequests/viewManager'
      path: '/requests/viewCertifiesRequests/viewManager'
      fullPath: '/requests/viewCertifiesRequests/viewManager'
      preLoaderRoute: typeof AuthenticatedRequestsViewCertifiesRequestsViewManagerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/instruments/serviceReport/addServiceReport': {
      id: '/_authenticated/instruments/serviceReport/addServiceReport'
      path: '/instruments/serviceReport/addServiceReport'
      fullPath: '/instruments/serviceReport/addServiceReport'
      preLoaderRoute: typeof AuthenticatedInstrumentsServiceReportAddServiceReportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/instruments/$id/edit': {
      id: '/_authenticated/instruments/$id/edit'
      path: '/instruments/$id/edit'
      fullPath: '/instruments/$id/edit'
      preLoaderRoute: typeof AuthenticatedInstrumentsIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/directory/$id/edit': {
      id: '/_authenticated/directory/$id/edit'
      path: '/directory/$id/edit'
      fullPath: '/directory/$id/edit'
      preLoaderRoute: typeof AuthenticatedDirectoryIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assistance/$id/edit': {
      id: '/_authenticated/assistance/$id/edit'
      path: '/assistance/$id/edit'
      fullPath: '/assistance/$id/edit'
      preLoaderRoute: typeof AuthenticatedAssistanceIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/viewTravel/$id/': {
      id: '/_authenticated/requests/viewTravel/$id/'
      path: '/requests/viewTravel/$id'
      fullPath: '/requests/viewTravel/$id/'
      preLoaderRoute: typeof AuthenticatedRequestsViewTravelIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/viewLeave/$id/': {
      id: '/_authenticated/requests/viewLeave/$id/'
      path: '/requests/viewLeave/$id'
      fullPath: '/requests/viewLeave/$id/'
      preLoaderRoute: typeof AuthenticatedRequestsViewLeaveIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/$id/visit/': {
      id: '/_authenticated/requests/$id/visit/'
      path: '/requests/$id/visit'
      fullPath: '/requests/$id/visit/'
      preLoaderRoute: typeof AuthenticatedRequestsIdVisitIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/$id/vacations/': {
      id: '/_authenticated/requests/$id/vacations/'
      path: '/requests/$id/vacations'
      fullPath: '/requests/$id/vacations/'
      preLoaderRoute: typeof AuthenticatedRequestsIdVacationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/$id/travels/': {
      id: '/_authenticated/requests/$id/travels/'
      path: '/requests/$id/travels'
      fullPath: '/requests/$id/travels/'
      preLoaderRoute: typeof AuthenticatedRequestsIdTravelsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/$id/leaves/': {
      id: '/_authenticated/requests/$id/leaves/'
      path: '/requests/$id/leaves'
      fullPath: '/requests/$id/leaves/'
      preLoaderRoute: typeof AuthenticatedRequestsIdLeavesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/$id/certifies/': {
      id: '/_authenticated/requests/$id/certifies/'
      path: '/requests/$id/certifies'
      fullPath: '/requests/$id/certifies/'
      preLoaderRoute: typeof AuthenticatedRequestsIdCertifiesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/instruments/serviceReport/$id/': {
      id: '/_authenticated/instruments/serviceReport/$id/'
      path: '/instruments/serviceReport/$id'
      fullPath: '/instruments/serviceReport/$id/'
      preLoaderRoute: typeof AuthenticatedInstrumentsServiceReportIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/instruments/report/$id/': {
      id: '/_authenticated/instruments/report/$id/'
      path: '/instruments/report/$id'
      fullPath: '/instruments/report/$id/'
      preLoaderRoute: typeof AuthenticatedInstrumentsReportIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/visitLog/$id/$visitId/addVisitLog': {
      id: '/_authenticated/visitLog/$id/$visitId/addVisitLog'
      path: '/visitLog/$id/$visitId/addVisitLog'
      fullPath: '/visitLog/$id/$visitId/addVisitLog'
      preLoaderRoute: typeof AuthenticatedVisitLogIdVisitIdAddVisitLogRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/viewTravel/$id/editTravel': {
      id: '/_authenticated/requests/viewTravel/$id/editTravel'
      path: '/requests/viewTravel/$id/editTravel'
      fullPath: '/requests/viewTravel/$id/editTravel'
      preLoaderRoute: typeof AuthenticatedRequestsViewTravelIdEditTravelRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/viewTravel/$id/detailTravelUser': {
      id: '/_authenticated/requests/viewTravel/$id/detailTravelUser'
      path: '/requests/viewTravel/$id/detailTravelUser'
      fullPath: '/requests/viewTravel/$id/detailTravelUser'
      preLoaderRoute: typeof AuthenticatedRequestsViewTravelIdDetailTravelUserRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/viewLeave/$id/detailLeaveUser': {
      id: '/_authenticated/requests/viewLeave/$id/detailLeaveUser'
      path: '/requests/viewLeave/$id/detailLeaveUser'
      fullPath: '/requests/viewLeave/$id/detailLeaveUser'
      preLoaderRoute: typeof AuthenticatedRequestsViewLeaveIdDetailLeaveUserRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/$id/visit/addRequest': {
      id: '/_authenticated/requests/$id/visit/addRequest'
      path: '/requests/$id/visit/addRequest'
      fullPath: '/requests/$id/visit/addRequest'
      preLoaderRoute: typeof AuthenticatedRequestsIdVisitAddRequestRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/$id/travels/addTravel': {
      id: '/_authenticated/requests/$id/travels/addTravel'
      path: '/requests/$id/travels/addTravel'
      fullPath: '/requests/$id/travels/addTravel'
      preLoaderRoute: typeof AuthenticatedRequestsIdTravelsAddTravelRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/instruments/serviceReport/$id/$draftId': {
      id: '/_authenticated/instruments/serviceReport/$id/$draftId'
      path: '/instruments/serviceReport/$id/$draftId'
      fullPath: '/instruments/serviceReport/$id/$draftId'
      preLoaderRoute: typeof AuthenticatedInstrumentsServiceReportIdDraftIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests/$id/travels/$travelId/updateTravel': {
      id: '/_authenticated/requests/$id/travels/$travelId/updateTravel'
      path: '/requests/$id/travels/$travelId/updateTravel'
      fullPath: '/requests/$id/travels/$travelId/updateTravel'
      preLoaderRoute: typeof AuthenticatedRequestsIdTravelsTravelIdUpdateTravelRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/instruments/serviceReport/$id/revision/$reportDocId/': {
      id: '/_authenticated/instruments/serviceReport/$id/revision/$reportDocId/'
      path: '/instruments/serviceReport/$id/revision/$reportDocId'
      fullPath: '/instruments/serviceReport/$id/revision/$reportDocId/'
      preLoaderRoute: typeof AuthenticatedInstrumentsServiceReportIdRevisionReportDocIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedLogoutRoute: typeof AuthenticatedLogoutRoute
  AuthenticatedMyProfileRoute: typeof AuthenticatedMyProfileRoute
  AuthenticatedNewCollaboratorRoute: typeof AuthenticatedNewCollaboratorRoute
  AuthenticatedNoteRoute: typeof AuthenticatedNoteRoute
  AuthenticatedReportRoute: typeof AuthenticatedReportRoute
  AuthenticatedUbicationRoute: typeof AuthenticatedUbicationRoute
  AuthenticatedUnauthorizedRoute: typeof AuthenticatedUnauthorizedRoute
  AuthenticatedUserRoute: typeof AuthenticatedUserRoute
  AuthenticatedWorkLogRoute: typeof AuthenticatedWorkLogRoute
  AuthenticatedActivityLazyRoute: typeof AuthenticatedActivityLazyRoute
  AuthenticatedEventsCalendarLazyRoute: typeof AuthenticatedEventsCalendarLazyRoute
  AuthenticatedInstrumentsAddInstrumentRoute: typeof AuthenticatedInstrumentsAddInstrumentRoute
  AuthenticatedInstrumentsListInstrumentsRoute: typeof AuthenticatedInstrumentsListInstrumentsRoute
  AuthenticatedAssistanceIndexLazyRoute: typeof AuthenticatedAssistanceIndexLazyRoute
  AuthenticatedDirectoryIndexLazyRoute: typeof AuthenticatedDirectoryIndexLazyRoute
  AuthenticatedHolidaysIndexLazyRoute: typeof AuthenticatedHolidaysIndexLazyRoute
  AuthenticatedRequestsIndexLazyRoute: typeof AuthenticatedRequestsIndexLazyRoute
  AuthenticatedAssistanceIdEditRoute: typeof AuthenticatedAssistanceIdEditRoute
  AuthenticatedDirectoryIdEditRoute: typeof AuthenticatedDirectoryIdEditRoute
  AuthenticatedInstrumentsIdEditRoute: typeof AuthenticatedInstrumentsIdEditRoute
  AuthenticatedInstrumentsServiceReportAddServiceReportRoute: typeof AuthenticatedInstrumentsServiceReportAddServiceReportRoute
  AuthenticatedRequestsViewCertifiesRequestsViewManagerRoute: typeof AuthenticatedRequestsViewCertifiesRequestsViewManagerRoute
  AuthenticatedRequestsViewCertifiesRequestsViewRrhhRoute: typeof AuthenticatedRequestsViewCertifiesRequestsViewRrhhRoute
  AuthenticatedRequestsViewCertifiesRequestsViewSupervisorRoute: typeof AuthenticatedRequestsViewCertifiesRequestsViewSupervisorRoute
  AuthenticatedRequestsViewLeaveListRequestRrhhRoute: typeof AuthenticatedRequestsViewLeaveListRequestRrhhRoute
  AuthenticatedRequestsViewTravelListRequestRrhhRoute: typeof AuthenticatedRequestsViewTravelListRequestRrhhRoute
  AuthenticatedRequestsViewVacationListRequestsAdminRoute: typeof AuthenticatedRequestsViewVacationListRequestsAdminRoute
  AuthenticatedRequestsViewVisitListRequestAdminRoute: typeof AuthenticatedRequestsViewVisitListRequestAdminRoute
  AuthenticatedAssistanceIdIndexRoute: typeof AuthenticatedAssistanceIdIndexRoute
  AuthenticatedDirectoryIdIndexRoute: typeof AuthenticatedDirectoryIdIndexRoute
  AuthenticatedInstrumentsIdIndexRoute: typeof AuthenticatedInstrumentsIdIndexRoute
  AuthenticatedVisitLogIdIndexRoute: typeof AuthenticatedVisitLogIdIndexRoute
  AuthenticatedInstrumentsServiceReportIdDraftIdRoute: typeof AuthenticatedInstrumentsServiceReportIdDraftIdRoute
  AuthenticatedRequestsIdTravelsAddTravelRoute: typeof AuthenticatedRequestsIdTravelsAddTravelRoute
  AuthenticatedRequestsIdVisitAddRequestRoute: typeof AuthenticatedRequestsIdVisitAddRequestRoute
  AuthenticatedRequestsViewLeaveIdDetailLeaveUserRoute: typeof AuthenticatedRequestsViewLeaveIdDetailLeaveUserRoute
  AuthenticatedRequestsViewTravelIdDetailTravelUserRoute: typeof AuthenticatedRequestsViewTravelIdDetailTravelUserRoute
  AuthenticatedRequestsViewTravelIdEditTravelRoute: typeof AuthenticatedRequestsViewTravelIdEditTravelRoute
  AuthenticatedVisitLogIdVisitIdAddVisitLogRoute: typeof AuthenticatedVisitLogIdVisitIdAddVisitLogRoute
  AuthenticatedInstrumentsReportIdIndexRoute: typeof AuthenticatedInstrumentsReportIdIndexRoute
  AuthenticatedInstrumentsServiceReportIdIndexRoute: typeof AuthenticatedInstrumentsServiceReportIdIndexRoute
  AuthenticatedRequestsIdCertifiesIndexRoute: typeof AuthenticatedRequestsIdCertifiesIndexRoute
  AuthenticatedRequestsIdLeavesIndexRoute: typeof AuthenticatedRequestsIdLeavesIndexRoute
  AuthenticatedRequestsIdTravelsIndexRoute: typeof AuthenticatedRequestsIdTravelsIndexRoute
  AuthenticatedRequestsIdVacationsIndexRoute: typeof AuthenticatedRequestsIdVacationsIndexRoute
  AuthenticatedRequestsIdVisitIndexRoute: typeof AuthenticatedRequestsIdVisitIndexRoute
  AuthenticatedRequestsViewLeaveIdIndexRoute: typeof AuthenticatedRequestsViewLeaveIdIndexRoute
  AuthenticatedRequestsViewTravelIdIndexRoute: typeof AuthenticatedRequestsViewTravelIdIndexRoute
  AuthenticatedRequestsIdTravelsTravelIdUpdateTravelRoute: typeof AuthenticatedRequestsIdTravelsTravelIdUpdateTravelRoute
  AuthenticatedInstrumentsServiceReportIdRevisionReportDocIdIndexRoute: typeof AuthenticatedInstrumentsServiceReportIdRevisionReportDocIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedLogoutRoute: AuthenticatedLogoutRoute,
  AuthenticatedMyProfileRoute: AuthenticatedMyProfileRoute,
  AuthenticatedNewCollaboratorRoute: AuthenticatedNewCollaboratorRoute,
  AuthenticatedNoteRoute: AuthenticatedNoteRoute,
  AuthenticatedReportRoute: AuthenticatedReportRoute,
  AuthenticatedUbicationRoute: AuthenticatedUbicationRoute,
  AuthenticatedUnauthorizedRoute: AuthenticatedUnauthorizedRoute,
  AuthenticatedUserRoute: AuthenticatedUserRoute,
  AuthenticatedWorkLogRoute: AuthenticatedWorkLogRoute,
  AuthenticatedActivityLazyRoute: AuthenticatedActivityLazyRoute,
  AuthenticatedEventsCalendarLazyRoute: AuthenticatedEventsCalendarLazyRoute,
  AuthenticatedInstrumentsAddInstrumentRoute:
    AuthenticatedInstrumentsAddInstrumentRoute,
  AuthenticatedInstrumentsListInstrumentsRoute:
    AuthenticatedInstrumentsListInstrumentsRoute,
  AuthenticatedAssistanceIndexLazyRoute: AuthenticatedAssistanceIndexLazyRoute,
  AuthenticatedDirectoryIndexLazyRoute: AuthenticatedDirectoryIndexLazyRoute,
  AuthenticatedHolidaysIndexLazyRoute: AuthenticatedHolidaysIndexLazyRoute,
  AuthenticatedRequestsIndexLazyRoute: AuthenticatedRequestsIndexLazyRoute,
  AuthenticatedAssistanceIdEditRoute: AuthenticatedAssistanceIdEditRoute,
  AuthenticatedDirectoryIdEditRoute: AuthenticatedDirectoryIdEditRoute,
  AuthenticatedInstrumentsIdEditRoute: AuthenticatedInstrumentsIdEditRoute,
  AuthenticatedInstrumentsServiceReportAddServiceReportRoute:
    AuthenticatedInstrumentsServiceReportAddServiceReportRoute,
  AuthenticatedRequestsViewCertifiesRequestsViewManagerRoute:
    AuthenticatedRequestsViewCertifiesRequestsViewManagerRoute,
  AuthenticatedRequestsViewCertifiesRequestsViewRrhhRoute:
    AuthenticatedRequestsViewCertifiesRequestsViewRrhhRoute,
  AuthenticatedRequestsViewCertifiesRequestsViewSupervisorRoute:
    AuthenticatedRequestsViewCertifiesRequestsViewSupervisorRoute,
  AuthenticatedRequestsViewLeaveListRequestRrhhRoute:
    AuthenticatedRequestsViewLeaveListRequestRrhhRoute,
  AuthenticatedRequestsViewTravelListRequestRrhhRoute:
    AuthenticatedRequestsViewTravelListRequestRrhhRoute,
  AuthenticatedRequestsViewVacationListRequestsAdminRoute:
    AuthenticatedRequestsViewVacationListRequestsAdminRoute,
  AuthenticatedRequestsViewVisitListRequestAdminRoute:
    AuthenticatedRequestsViewVisitListRequestAdminRoute,
  AuthenticatedAssistanceIdIndexRoute: AuthenticatedAssistanceIdIndexRoute,
  AuthenticatedDirectoryIdIndexRoute: AuthenticatedDirectoryIdIndexRoute,
  AuthenticatedInstrumentsIdIndexRoute: AuthenticatedInstrumentsIdIndexRoute,
  AuthenticatedVisitLogIdIndexRoute: AuthenticatedVisitLogIdIndexRoute,
  AuthenticatedInstrumentsServiceReportIdDraftIdRoute:
    AuthenticatedInstrumentsServiceReportIdDraftIdRoute,
  AuthenticatedRequestsIdTravelsAddTravelRoute:
    AuthenticatedRequestsIdTravelsAddTravelRoute,
  AuthenticatedRequestsIdVisitAddRequestRoute:
    AuthenticatedRequestsIdVisitAddRequestRoute,
  AuthenticatedRequestsViewLeaveIdDetailLeaveUserRoute:
    AuthenticatedRequestsViewLeaveIdDetailLeaveUserRoute,
  AuthenticatedRequestsViewTravelIdDetailTravelUserRoute:
    AuthenticatedRequestsViewTravelIdDetailTravelUserRoute,
  AuthenticatedRequestsViewTravelIdEditTravelRoute:
    AuthenticatedRequestsViewTravelIdEditTravelRoute,
  AuthenticatedVisitLogIdVisitIdAddVisitLogRoute:
    AuthenticatedVisitLogIdVisitIdAddVisitLogRoute,
  AuthenticatedInstrumentsReportIdIndexRoute:
    AuthenticatedInstrumentsReportIdIndexRoute,
  AuthenticatedInstrumentsServiceReportIdIndexRoute:
    AuthenticatedInstrumentsServiceReportIdIndexRoute,
  AuthenticatedRequestsIdCertifiesIndexRoute:
    AuthenticatedRequestsIdCertifiesIndexRoute,
  AuthenticatedRequestsIdLeavesIndexRoute:
    AuthenticatedRequestsIdLeavesIndexRoute,
  AuthenticatedRequestsIdTravelsIndexRoute:
    AuthenticatedRequestsIdTravelsIndexRoute,
  AuthenticatedRequestsIdVacationsIndexRoute:
    AuthenticatedRequestsIdVacationsIndexRoute,
  AuthenticatedRequestsIdVisitIndexRoute:
    AuthenticatedRequestsIdVisitIndexRoute,
  AuthenticatedRequestsViewLeaveIdIndexRoute:
    AuthenticatedRequestsViewLeaveIdIndexRoute,
  AuthenticatedRequestsViewTravelIdIndexRoute:
    AuthenticatedRequestsViewTravelIdIndexRoute,
  AuthenticatedRequestsIdTravelsTravelIdUpdateTravelRoute:
    AuthenticatedRequestsIdTravelsTravelIdUpdateTravelRoute,
  AuthenticatedInstrumentsServiceReportIdRevisionReportDocIdIndexRoute:
    AuthenticatedInstrumentsServiceReportIdRevisionReportDocIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
